import React, { Component } from 'react';
import './StatModelMoreInfo.css';
import Table from 'react-bootstrap/Table';
import { MathComponent } from "mathjax-react";
import MoreInfoTables, { requests, tables } from './Tables/MoreInfoTables';

class InnerStatisticalModel extends Component {
    render () {
        return (
          <div>
            <p>
              A statistical model estimates the postoperative (one year after implantation) binaural aided CNC score using statistical relationships between preoperative factors and their postoperative score. These relationships are expressed in a linear mathematical equation, which produces a numerical value. An additional algorithm is used to estimate a 90% prediction interval which is a function of the uncertainty or degree of error of the model and the estimated score. The prediction interval provides a range of possible outcomes.
            </p>
            <p>Equations 1 to 3 are the mathematical expression of the model:</p>
            <div>
              <Table>
                <tbody>
                  <tr>
                    <td>
                      <MathComponent tex={String.raw`CNC_{postop} = \beta_0 + \sum_{i=1}^{m}{\beta_m x_m + \varepsilon}`}  />
                    </td>
                    <td>(1)</td>
                  </tr>
                  <tr>
                    <td>
                      <MathComponent tex={String.raw`PI = CNC_{postop} + f(model\ uncertainty)`} />
                    </td>
                    <td>(2)</td>
                  </tr>
                  <tr>
                    <td>
                      <MathComponent tex={String.raw`CNC_{range} = PI`} />
                    </td>
                    <td>(3)</td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <p>
              where <MathComponent tex={String.raw`CNC_{postop}`} display={false} /> is the estimated postoperative <MathComponent tex={String.raw`CNC`} display={false} /> word score; <MathComponent tex={String.raw`\beta_0`} display={false} /> is a constant, <MathComponent tex={String.raw`\beta_m`} display={false} /> is the coefficient of input variable <MathComponent tex={String.raw`x_m`} display={false} /> ; <MathComponent tex={String.raw`\varepsilon`} display={false} />  is the error or uncertainty term; <MathComponent tex={String.raw`PI`} display={false} />  is the prediction which is a function of the estimated score and the model uncertainty; and <MathComponent tex={String.raw`CNC_{range}`} display={false} /> is the range of possible outcomes for postoperative <MathComponent tex={String.raw`CNC`} display={false} />  word score.
            </p>
            <p>
              A general linear model (GLM) modelling approach was used to develop the statistical model and estimate the constant and coefficients. More specifically, the Python library Scikit-learn’s Bayesian Ridge Regression algorithm (least squares regression with regularization) was used to estimate the constant and coefficients. Scikit-learn’s Sequential Feature Selector was used to select the input variables that maximise the model’s accuracy. It does this by:            
            </p>
            <ol>
              <li>Splitting the model training dataset according to a cross-fold approach</li>
              <li>In a stepwise approach and until a specified maximum number of variables are selected:
                <ul>
                  <li>For each possible variable out of a list of remaining variables, with the inclusion of the variable in the model, the model’s coefficients were estimated, and the corresponding performance was estimated</li>
                  <li>The variable with the greatest performance is selected</li>
                </ul>
              </li>
            </ol>

            <p>The selected input variables of the model are as follows:</p>
            <ul className="moreinfo-ul">
              <li>Intercept or constant</li>
              <li>SSQ-49 questions</li>
              <li>Preoperative word score</li>
              <li>Age</li>
              <li>Duration of hearing loss</li>
              <li>Audiogram</li>
              <li>Average daily time using the cochlear implant (TOA)</li>
            </ul>
            <p>
              Recipient’s time using the cochlear implant system has been found to be positively correlated with postoperative performance [11]. Holder et al. [12] ran an interventional study and promoted the increase in cochlear implantation system usage for 20 patients. They found that 17 out of the 20 patients increased their average daily usage and the increase in usage was positively correlated with aided hearing performance on CNC words, AzBio sentences and AzBio sentences in noise. While this predictor is a postoperative factor, the use of the model can be used with an assumed average TOA.
            </p>
            <p>
              The Referral Support Tool use of the model will be with the assumption that the TOA of the hypothetical recipient is 12 hrs/day. This is in line with research conducted by Busch, Vanpoucke and Wieringen [13] that found that the median TOA of adults and seniors is ~ 12 hrs/day.
            </p>
            <p>
              Subjects of the Clinical Studies were divided into two subsets: training (~66 %) and tuning (~34 %). The model development set was used to identify characteristics that correlate with change in aided CNC scores such as the model input variables. The tuning set was used to identify the best model and to estimate model performance. The performance statistics of the model are recorded in Table <MoreInfoTables table={tables.PrototypeModelAccuracy} request={requests.Index} />. These performance statistics can be compared with a naïve model (Table <MoreInfoTables table={tables.NaiveModelAccuracy} request={requests.Index} />) which is the average postoperative (one year after implantation) CNC score being used as the estimate.The model outperforms the naïve model The performance statistics are the coefficient of determination(R2), root mean square error (RMSE) and mean absolute error (MAE).  
            </p>
            <div>
              <MoreInfoTables table={tables.PrototypeModelAccuracy} request={requests.Title}/>
              <MoreInfoTables table={tables.PrototypeModelAccuracy} />
            </div>
            <div>
              <MoreInfoTables table={tables.NaiveModelAccuracy} request={requests.Title}/>
              <MoreInfoTables table={tables.NaiveModelAccuracy} />
            </div>            
          </div> 
          );
    }
}

export default InnerStatisticalModel;